import React, { FC } from "react";
import Moment from "react-moment";
import { useTranslation } from "../../plugins/i18next/ea-react-i18next";
import { ArticleEdge, BaseQueryData } from "../../utils/core";
import LegalNav from "./LegalNav";


const DetailsContents: FC<{ data: BaseQueryData<ArticleEdge> }> = ({ data }) => {
    const { t } = useTranslation("", { keyPrefix: 'article.articledetailscontent' });

    if (!data)
        return <></>;

    const { frontmatter, html } = data;
    const { title, date } = frontmatter;
   
    return (
        <section>
            <div className="container-fluid legal-content hero-container" >
                <div className="row">
                    <div className="col-lg-8 col-md-12">
                        <h1>{title}</h1>
                        <div className="lastUpdate">
                            <span>{t('lastupdated')}</span>: <Moment format="L">{date}</Moment>    
                        </div>                            
                        <div dangerouslySetInnerHTML={{ __html: html }} />
                    </div>

                    <div className="col-lg-4 col-md-12 privacyNav">
                        <LegalNav />
                    </div>
                </div>
            </div>
        </section>
    );
}

export default DetailsContents;
